var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"预览数据","visible":_vm.dialogVisible,"width":"800px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('span',[_vm._v("表格数据")])])}
var staticRenderFns = []

export { render, staticRenderFns }